import { Text } from '@driftt/dds'
import React from 'react'

import { PersonaFormAttributes } from '../types'

interface ListComponent {
  changes: PersonaFormAttributes[]
  showTitle?: boolean
  title: string
}

export const ListComponent = ({
  changes,
  title,
  showTitle = true,
}: ListComponent) => (
  <section>
    {showTitle && Boolean(changes.length) && (
      <Text variant="bodyBold">{title}</Text>
    )}
    <ul style={{ listStyle: 'disc', margin: '0 0 0 -1rem ' }}>
      {changes.map(({ name, operator, value }, index) => (
        <li key={`${name?.label}-${index}-updated`}>
          <Text inline variant="bodyBold">
            {name?.label}
          </Text>
          <Text
            inline
            variant="body"
            css={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}
          >
            {operator?.label}
          </Text>
          <Text inline variant="bodyBold">
            {Array.isArray(value) ? value?.join?.(', ') : value}
          </Text>
        </li>
      ))}
    </ul>
  </section>
)
